export default __webpack_public_path__ + "static/media/GaugeImg2.25831b29.jpg";